import React from 'react';
import PropTypes from 'prop-types';

function Loader({ size = 'md', className = '' }) {
  // Determine the size of the loader
  const sizeClasses = {
    'sm': 'h-4 w-4',
    'md': 'h-8 w-8',
    'lg': 'h-12 w-12',
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`absolute inset-0 flex items-center justify-center bg-white rounded-xl ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-gray-900 ${spinnerSize}`}></div>
    </div>
  );
}

Loader.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default Loader;